<template>
  <div class="addOrder" style="height: 0px;">
    <el-tabs v-model="show.tab" @tab-click="tabClick">
      <el-tab-pane :label="util.language('选择店铺', 'Select Shop')" name="tabShop">
        <div style="max-width: 900px; margin: auto;">
          <el-row :gutter="20" style="margin: 20px;">
            <el-col :span="12" v-for="shopItem in show.shopList" :key="shopItem.id">
              <el-card style="width: 100%; height: 250px;cursor: pointer; margin-bottom: 20px;" shadow="hover" @click="changeShop(shopItem)" :style="{ 'background-color': shopItem.id == data.shop?.id ? '' : 'rgb(243.9, 244.2, 244.8)' }">
                <div>
                  <el-text style="color: #000; font-weight: bolder; font-size: larger;">{{ util.language(shopItem.cnName, shopItem.enName) }}</el-text>
                  <el-text style="margin-left: 10px;">{{ shopItem.code }}</el-text>
                  <el-text type="primary" style="float: right; font-size: larger;" v-if="shopItem.id == data.shop?.id">
                    <el-icon>
                      <SuccessFilled />
                    </el-icon>
                  </el-text>
                  <br />
                  <template v-if="shopItem.hstRate">
                    <el-text style="margin-left: 10px;">{{ util.language('统一销售税（HST）：', 'Harmonized Sales Tax: ') + math.multiply(shopItem.hstRate, 100) }}%</el-text>
                    <br />
                  </template>
                  <template v-if="shopItem.gstRate">
                    <el-text style="margin-left: 10px;">{{ util.language('联邦销售税（GST）：', 'Goods and Services Tax: ') + math.multiply(shopItem.gstRate, 100) }}%</el-text>
                    <br />
                  </template>
                  <template v-if="shopItem.pstRate">
                    <el-text style="margin-left: 10px;">{{ util.language('省级销售税（PST）：', 'Provincial Sales Tax: ') + math.multiply(shopItem.pstRate, 100) }}%</el-text>
                    <br />
                  </template>
                  <template v-if="shopItem.qstRate">
                    <el-text style="margin-left: 10px;">{{ util.language('魁北克消费税（QST）：', 'Quebec Sales Tax: ') + math.multiply(shopItem.qstRate, 100) }}%</el-text>
                    <br />
                  </template>
                </div>
                <div>
                  <el-text>{{ shopItem.phone }}</el-text>
                </div>
                <div style="height: 90px; overflow: hidden;">
                  <el-text>{{ shopItem.addressDetail }}</el-text>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="util.language('选择客户', 'Select customer')" name="tabCustomer">
        <template v-if="data.customer == null">
          <el-form :inline="true">
            <el-form-item :label="util.language('编码', 'Code')">
              <el-input style="width: 120px;" :placeholder="util.language('模糊匹配', 'Fuzzy')" v-model="customerSearchParam.codeLike" clearable />
            </el-form-item>
            <el-form-item :label="util.language('电话号', 'Phone')">
              <el-input style="width: 120px;" :placeholder="util.language('模糊匹配', 'Fuzzy')" v-model="customerSearchParam.phoneLike" clearable />
            </el-form-item>
            <el-form-item :label="util.language('名称', 'Name')">
              <el-input style="width: 120px;" :placeholder="util.language('模糊匹配', 'Fuzzy')" v-model="customerSearchParam.nameLike" clearable />
            </el-form-item>
            <el-form-item>
              <el-button-group>
                <el-button type="primary" @click="commitFindCustomer()" :loading="loading.customer">{{ util.language('搜索', 'Search') }}</el-button>
                <el-button @click="resetCustomerSearchParam()">{{ util.language('重置', 'Reset') }}</el-button>
              </el-button-group>
            </el-form-item>
          </el-form>
          <div style="height: 10px;"></div>
          <el-table :data="show.customerList" border style="height: calc(100vh - 200px);" v-loading="loading.customer">
            <el-table-column prop="code" align="center" :label="util.language('编码', 'Code')" width="100" show-overflow-tooltip>
              <template #default="scope">
                <el-link type="primary" @click="selectCustomer(scope.row)">{{ util.language('选中', 'Select') }}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="code" :label="util.language('编码', 'Code')" width="100" show-overflow-tooltip />
            <el-table-column prop="shopCode" :label="util.language('店铺', 'Shop')" width="80" show-overflow-tooltip>
              <template #default="scope">
                <el-text>{{show.shopList.filter(item => item.id == scope.row.shopId).map(item => item.code)[0]}}</el-text>
              </template>
            </el-table-column>
            <el-table-column prop="phone" :label="util.language('电话号', 'Phone')" width="150" show-overflow-tooltip />
            <el-table-column prop="name" :label="util.language('名称', 'Name')" width="150" show-overflow-tooltip />
            <el-table-column prop="enable" align="center" :label="util.language('状态', 'State')" width="100">
              <template #default="scope">
                <el-tag v-if="scope.row.enable" type="success">{{ util.language('启用', 'Enable') }}</el-tag>
                <el-tag v-else type="danger">{{ util.language('停用', 'Disable') }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="finishOrderCount" :label="util.language('订单数', 'Finished')" width="100" show-overflow-tooltip />
            <el-table-column prop="customerNote" :label="util.language('客户备注', 'Customer note')" width="130" show-overflow-tooltip />
            <el-table-column prop="insiderNote" :label="util.language('内部备注', 'Insider note')" min-width="100" show-overflow-tooltip />
          </el-table>
        </template>
        <template v-else>
          <el-divider content-position="left">{{ util.language('已选中客户', 'Selected Customer') }}</el-divider>
          <div>
            <el-form :inline="true">
              <el-form-item>
                <el-text style="color: #000;">{{ data.customer.name }}</el-text>
                <el-text style="margin-left: 20px;">{{ data.customer.code }}</el-text>
                <el-text style="margin-left: 20px;">{{ data.customer.phone }}</el-text>
                <el-button size="small" @click="reselectCustomer()" style="margin-left: 20px;">{{ util.language('重选客户', 'Reset Customer') }}</el-button>
              </el-form-item>
            </el-form>
            <el-form :inline="true">
              <el-form-item :label="util.language('预约送货日期', 'Schedule delivery date')">
                <el-date-picker v-model="data.scheduleDeliveryDate" size="small" value-format="YYYY-MM-DD" type="date" />
              </el-form-item>
            </el-form>
          </div>
          <el-divider content-position="left">
            <span>{{ util.language('客户的地址', 'Customer address') }}</span>
            <el-button size="small" @click="getCustomerAddress" style="margin-left: 20px;" :loading="loading.customerAddress">
              <el-icon>
                <Refresh />
              </el-icon>
              {{ util.language('刷新', 'Refresh') }}
            </el-button>
          </el-divider>
          <el-row v-loading="loading.customerAddress">
            <el-col :span="6" v-for="address in show.customerAddressList" :key="address.id">
              <el-card shadow="hover" style="margin: 10px; height: 175px;overflow: hidden;cursor: pointer;" @click="addressClick(address)"
                :style="{ 'background-color': data.customerAddress && address.id === data.customerAddress.id ? '' : 'rgb(243.9, 244.2, 244.8)' }">
                <div style="display: flex;justify-content: space-between;">
                  <div>
                    <div>
                      <el-text style="color: #000;">{{ address.contact }}</el-text>
                    </div>
                    <div>
                      <el-text>{{ address.phone }}</el-text>
                    </div>
                  </div>
                  <div>
                    <el-text type="primary" style="float: right; font-size: larger;" v-if="data.customerAddress && address.id === data.customerAddress.id">
                      <el-icon>
                        <SuccessFilled />
                      </el-icon>
                    </el-text>
                  </div>
                </div>
                <div>
                  <el-text>{{ address.addressDetail }}</el-text>
                </div>
              </el-card>
            </el-col>
            <el-col :span="6">
              <el-card shadow="hover" style="margin: 10px; height: 175px;overflow: hidden;cursor: pointer;background-color: rgb(243.9, 244.2, 244.8)" @click="addAddressClick">
                <div style="width: 100%; margin-top: 55px; text-align: center;">
                  <el-text>
                    <el-icon>
                      <Plus />
                    </el-icon>
                    {{ util.language('新增地址', 'New address') }}
                  </el-text>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </template>
      </el-tab-pane>
      <el-tab-pane :label="util.language('选择商品', 'Select product')" name="tabProduct">
        <el-tabs v-model="show.productTypeTab" tab-position="left" @tab-click="productTypeClick" v-loading="loading.findProduct">
          <el-tab-pane :label="util.language('搜索', 'Search')" name="search">
            <el-form :inline="true">
              <el-form-item :label="util.language('编码', 'Code')">
                <el-input style="width: 120px;" :placeholder="util.language('模糊匹配', 'Fuzzy')" v-model="productSearchParam.codeLike" clearable />
              </el-form-item>
              <el-form-item :label="util.language('名称', 'Name')">
                <el-input style="width: 120px;" :placeholder="util.language('模糊匹配', 'Fuzzy')" v-model="productSearchParam.nameLike" clearable />
              </el-form-item>
              <el-form-item>
                <el-button-group>
                  <el-button type="primary" @click="commitFindProduct(true)" :loading="loading.findProduct">{{ util.language('搜索', 'Search') }}</el-button>
                  <el-button @click="resetProductSearchParam()">{{ util.language('重置', 'Reset') }}</el-button>
                </el-button-group>
              </el-form-item>
            </el-form>
            <el-row>
              <el-col :span="6" v-for="product in show.productList" :key="product.id">
                <el-card shadow="hover" style="margin: 10px;cursor: pointer;" @click="addProduct(product)" :style="{ 'background-color': data.productList.filter(item => item.id === product.id).length != 0 ? '' : 'rgb(243.9, 244.2, 244.8)' }">
                  <div style="display: flex;justify-content: center" @click.stop="() => { }">
                    <el-image style="width: 200px; height: 200px; margin: auto;" :src="product.img" :preview-src-list="[product.img]" fit="cover" />
                  </div>
                  <div style="margin-top: 10px; height: 45px; overflow: hidden;">
                    <div>
                      <el-text>{{ product.code }}</el-text>
                      <el-text style="color: #000;margin-left: 5px;">{{ util.language(product.cnName, product.enName) }}</el-text>
                    </div>
                  </div>
                  <div>
                  </div>
                  <div style="line-height: 25px; vertical-align: bottom;">
                    <el-text type="danger" style="font-size: 25px;">C${{ math.multiply(product.unitPrice, product.unitPerPiece) }}</el-text>
                    <el-text>(C${{ product.unitPrice }}/{{ product.unit }} * {{ product.unitPerPiece }}{{ product.unit }}/{{ util.language('件', 'piece') }})</el-text>
                    <el-text style="margin-left: 5px;" type="primary" v-if="!product.hasTax">{{ util.language('免税', 'No Tax') }}</el-text>
                  </div>
                  <div style="display: flex;justify-content: space-between;">
                    <div>
                      <div>
                        <el-text>{{ util.language('进价：', 'Purchase: ') }}</el-text>
                        <el-text>C${{ product.unitPriceIn || '-' }}</el-text>
                      </div>
                      <div>
                        <el-text>{{ util.language('库存： ', 'INV QTY: ') }}</el-text>
                        <el-text>{{ product.pieceInventoryQuantity || '-' }}</el-text>
                      </div>
                    </div>
                    <div>
                      <div style="width: 120px; text-align: right;">
                        <el-input-number style="width: 120px;" v-model="data.productList.filter(item => item.id === product.id)[0].quantity" :min="1" :max="product.pieceInventoryQuantity"
                          v-if="data.productList.filter(item => item.id === product.id).length != 0" />
                      </div>
                    </div>
                  </div>
                  <div style="height: 45px; overflow: hidden;">
                    <el-text>{{ util.language('内部备注： ', 'Insider note: ') }}</el-text>
                    <el-text>{{ product.insiderNote || '-' }}</el-text>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane v-for="productType in show.productTypeList" :key="productType.id" :label="util.language(productType.cnName, productType.enName)" :name="productType.id">
            <el-row>
              <el-col :span="6" v-for="product in show.productList" :key="product.id">
                <el-card shadow="hover" style="margin: 10px;cursor: pointer;" @click="addProduct(product)" :style="{ 'background-color': data.productList.filter(item => item.id === product.id).length != 0 ? '' : 'rgb(243.9, 244.2, 244.8)' }">
                  <div style="display: flex;justify-content: center" @click.stop="() => { }">
                    <el-image style="width: 200px; height: 200px; margin: auto;" :src="product.img" :preview-src-list="[product.img]" fit="cover" />
                  </div>
                  <div style="margin-top: 10px; height: 45px; overflow: hidden;">
                    <div>
                      <el-text>{{ product.code }}</el-text>
                      <el-text style="color: #000;margin-left: 5px;">{{ util.language(product.cnName, product.enName) }}</el-text>
                    </div>
                  </div>
                  <div>
                  </div>
                  <div style="line-height: 25px; vertical-align: bottom;">
                    <el-text type="danger" style="font-size: 25px;">C${{ math.multiply(product.unitPrice, product.unitPerPiece) }}</el-text>
                    <el-text>(C${{ product.unitPrice }}/{{ product.unit }} * {{ product.unitPerPiece }}{{ product.unit }}/{{ util.language('件', 'piece') }})</el-text>
                    <el-text style="margin-left: 5px;" type="primary" v-if="!product.hasTax">{{ util.language('免税', 'No Tax') }}</el-text>
                  </div>
                  <div style="display: flex;justify-content: space-between;">
                    <div>
                      <div>
                        <el-text>{{ util.language('进价：', 'Purchase: ') }}</el-text>
                        <el-text>C${{ product.unitPriceIn || '-' }}</el-text>
                      </div>
                      <div>
                        <el-text>{{ util.language('库存： ', 'INV QTY: ') }}</el-text>
                        <el-text>{{ product.pieceInventoryQuantity || '-' }}</el-text>
                      </div>
                    </div>
                    <div>
                      <div style="width: 120px; text-align: right;">
                        <el-input-number style="width: 120px;" v-model="data.productList.filter(item => item.id === product.id)[0].quantity" :min="1" :max="product.pieceInventoryQuantity"
                          v-if="data.productList.filter(item => item.id === product.id).length != 0" />
                      </div>
                    </div>
                  </div>
                  <div style="height: 45px; overflow: hidden;">
                    <el-text>{{ util.language('内部备注： ', 'Insider note: ') }}</el-text>
                    <el-text>{{ product.insiderNote || '-' }}</el-text>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="24">
                <el-card shadow="hover" style="height: 58px;margin: 10px;">
                  <div style="display: flex;justify-content: center">
                    <el-link style="margin: auto;" v-if="show.productList.length < show.productTotal" @click="nextProductPage">{{ util.language('继续加载 ', 'More') }}</el-link>
                    <el-link style="margin: auto;" v-else>{{ util.language('没有更多商品了 ', 'No more products') }}</el-link>
                  </div>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
      <el-tab-pane :label="util.language('已选择商品', 'Selected products') + '(' + data.productList.length + ')'" name="tabCart">
        <el-table :data="data.productList" border>
          <el-table-column prop="code" :label="util.language('编码', 'Product Code')" width="150" show-overflow-tooltip />
          <el-table-column :label="util.language('名称', 'Product Name')" min-width="150" show-overflow-tooltip>
            <template #default="scope">
              <el-text>{{ util.language(scope.row.cnName, scope.row.enName) }}</el-text>
            </template>
          </el-table-column>
          <el-table-column :label="util.language('数量(件) / 库存 ', 'QTY / Inventory')" width="230" show-overflow-tooltip>
            <template #default="scope">
              <el-input-number style="width: 140px;" v-model="scope.row.quantity" :precision="0" :min="1" :max="scope.row.pieceInventoryQuantity" />
              <el-text style="margin-left: 5px;"> / {{ scope.row.pieceInventoryQuantity }}</el-text>
            </template>
          </el-table-column>
          <el-table-column align="right" :label="util.language('税率', 'Tax rate')" width="90" show-overflow-tooltip>
            <template #default="scope">
              <el-text v-if="data.shop">{{ scope.row.hasTax ? math.formatNumber(math.multiply(
                math.plus(data.shop.hstRate, data.shop.gstRate, data.shop.pstRate, data.shop.qstRate)
                , 100), 4) + '%' : '0%' }}</el-text>
            </template>
          </el-table-column>
          <el-table-column align="right" :label="util.language('进价', 'Purchase price')" width="130" show-overflow-tooltip>
            <template #default="scope">
              <el-text>{{ math.formatNumber(scope.row.unitPriceIn) }}</el-text>
            </template>
          </el-table-column>
          <el-table-column align="right" :label="util.language('金额', 'Price')" width="450">
            <template #default="scope">
              <el-text>{{ scope.row.quantity }}{{ util.language('件', 'piece') }}</el-text>
              <el-text> * </el-text>
              <el-text>{{ scope.row.unitPerPiece }} {{ scope.row.unit }}/{{ util.language('件', 'piece') }}</el-text>
              <el-text> * </el-text>
              <el-text>C$</el-text>
              <el-input-number size="small" :controls="false" style="width: 75px;" v-model="scope.row.unitPrice" :precision="2" :min="scope.row.unitPriceIn" />
              <el-text>/{{ scope.row.unit }}</el-text>
              <el-text> = </el-text>
              <el-text type="danger" style="font-size: large; font-weight: bolder;">C${{ math.formatNumber(math.halfUp(math.multiply(scope.row.quantity, scope.row.unitPerPiece, scope.row.unitPrice), 2)) }}</el-text>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="enable" label="" width="45">
            <template #default="scope">
              <el-link type="danger" @click="removeProduct(scope.row)" :underline="false">
                <el-icon>
                  <DeleteFilled />
                </el-icon>
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <div style="height: 10px;"></div>
        <el-form :inline="true" style="text-align: right;">
          <el-form-item :label="util.language('商品总价', 'Product amount')">
            <el-text type="danger">C${{ totalAmount }}</el-text>
          </el-form-item>
          <el-form-item :label="util.language('总成本', 'Total cost')">
            <el-text type="danger">C${{ totalCost }}</el-text>
          </el-form-item>
          <el-form-item v-if="data.shop.hstRate" :label="util.language('HST税费', 'HST amount')">
            <el-text type="danger">C${{ hstAmount }}</el-text>
          </el-form-item>
          <el-form-item v-if="data.shop.gstRate" :label="util.language('GST税费', 'GST amount')">
            <el-text type="danger">C${{ gstAmount }}</el-text>
          </el-form-item>
          <el-form-item v-if="data.shop.pstRate" :label="util.language('PST税费', 'PST amount')">
            <el-text type="danger">C${{ pstAmount }}</el-text>
          </el-form-item>
          <el-form-item v-if="data.shop.qstRate" :label="util.language('QST税费', 'QST amount')">
            <el-text type="danger">C${{ qstAmount }}</el-text>
          </el-form-item>
          <el-form-item :label="util.language('税后优惠', 'Discount amount')">
            <el-input-number style="width: 140px;" v-model="data.discountAmount" :precision="2" :min="0" :max="math.plus(totalAmount, taxAmount)" />
          </el-form-item>
          <el-form-item :label="util.language('总利润', 'Total profit')">
            <el-text type="danger">C${{ math.plus(totalAmount, -totalCost, -data.discountAmount) }}</el-text>
          </el-form-item>
          <el-form-item :label="util.language('利润率', 'Profit rate')">
            <el-text type="danger">{{ math.halfUp(math.divide(math.plus(totalAmount, -totalCost, -data.discountAmount), totalAmount, 0.01), 2) + '%' }}</el-text>
          </el-form-item>
          <el-form-item :label="util.language('订单总价', 'Final amount')">
            <el-text type="danger" style="font-size: large; font-weight: bolder;">C${{ math.formatNumber(math.plus(totalAmount, taxAmount, -data.discountAmount)) }}</el-text>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane :label="util.language('确认订单', 'Confirm')" name="tabOrder">
        <el-row :gutter="40">
          <el-col :span="10">
            <el-divider content-position="left">{{ util.language('下单店铺', 'Shop') }}</el-divider>
            <template v-if="data.shop">
              <div>
                <el-text>{{ util.language('店铺：', 'Shop: ') }}</el-text>
                <el-text>{{ util.language(data.shop.cnName, data.shop.enName) }}</el-text>
                <el-text style="margin-left: 10px;">{{ data.shop.code }}</el-text>
                <el-text style="margin-left: 40px;">{{ util.language('电话：', 'Phone: ') }}</el-text>
                <el-text>{{ data.shop.phone }}</el-text>
              </div>
              <div>
                <el-text style="width: 100px;">{{ util.language('地址：', 'Address: ') }}</el-text>
                <el-text>{{ data.shop.addressDetail }}</el-text>
              </div>
            </template>
            <template v-else>
              <el-text>{{ util.language('未选择店铺', 'Shop not selected') }}</el-text>
            </template>
            <el-divider content-position="left">{{ util.language('客户信息', 'Customer') }}</el-divider>
            <template v-if="data.customer && data.customerAddress">
              <div>
                <el-text>{{ util.language('客户：', 'Customer: ') }}</el-text>
                <el-text>{{ data.customer.name }}</el-text>
                <el-text style="margin-left: 10px;">{{ data.customer.code }}</el-text>
                <el-text style="margin-left: 40px;">{{ util.language('客户电话：', 'Phone: ') }}</el-text>
                <el-text>{{ data.customer.phone }}</el-text>
              </div>
              <div>
                <el-text>{{ util.language('送货联系人： ', 'Contact: ') }}</el-text>
                <el-text>{{ data.customerAddress.contact }}</el-text>
                <el-text style="margin-left: 40px;">{{ util.language('送货联系电话： ', 'Phone: ') }}</el-text>
                <el-text>{{ data.customerAddress.phone }}</el-text>
              </div>
              <div>
                <el-text style="width: 100px;">{{ util.language('地址： ', 'Address: ') }}</el-text>
                <el-text>{{ data.customerAddress.addressDetail }}</el-text>
              </div>
              <div>
                <el-text style="width: 100px;">{{ util.language('预约送货日期： ', 'Schedule delivery date: ') }}</el-text>
                <el-text v-if="data.scheduleDeliveryDate">{{ data.scheduleDeliveryDate }}</el-text>
                <el-text type="danger" style="font-weight: bold;" v-else>{{ util.language('未填写 ', 'Not filled') }}</el-text>
              </div>
            </template>
            <template v-else>
              <el-text>{{ util.language('未选择客户 / 收货地址 ', 'Customer & Address not selected') }}</el-text>
            </template>
          </el-col>
          <el-col :span="14">
            <el-divider content-position="left">{{ util.language('订单备注', 'Note') }}</el-divider>
            <el-form>
              <el-form-item :label="util.language('客户备注', 'Customer note')">
                <el-input :placeholder="util.language('由客户填写', 'Filled by customer')" disabled />
              </el-form-item>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="util.language('订单备注', 'Order note')">
                    <el-input type="textarea" :rows="3" v-model="data.orderNote" :placeholder="util.language('客户可见', 'Visible to customer')" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="util.language('内部备注', 'Insider note')">
                    <el-input type="textarea" :rows="3" v-model="data.insiderNote" :placeholder="util.language('仅后台可见', 'Visible to backend only')" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
          <el-col :span="24">
            <el-divider content-position="left">{{ util.language('商品详情 ', 'Products') }}</el-divider>
            <template v-if="data.productList.length > 0">
              <el-table :data="data.productList">
                <el-table-column prop="code" :label="util.language('商品编号', 'Product Code')" width="150" show-overflow-tooltip />
                <el-table-column :label="util.language('商品名称', 'Product Name')" min-width="150" show-overflow-tooltip>
                  <template #default="scope">
                    <el-text>{{ util.language(scope.row.cnName, scope.row.enName) }}</el-text>
                  </template>
                </el-table-column>
                <el-table-column align="right" :label="util.language('金额', 'Amount')" width="450">
                  <template #default="scope">
                    <el-text>{{ scope.row.quantity }}{{ util.language('件', 'piece') }}</el-text>
                    <el-text> * </el-text>
                    <el-text>{{ scope.row.unitPerPiece }} {{ scope.row.unit }}/{{ util.language('件', 'piece') }}</el-text>
                    <el-text> * </el-text>
                    <el-text type="primary">C${{ scope.row.unitPrice }}/{{ scope.row.unit }}</el-text>
                    <el-text> = </el-text>
                    <el-text type="danger" style="font-size: large; font-weight: bolder;">C${{ math.formatNumber(math.halfUp(math.multiply(scope.row.quantity, scope.row.unitPerPiece, scope.row.unitPrice), 2)) }}</el-text>
                  </template>
                </el-table-column>
                <el-table-column align="right" :label="util.language('税率', 'Tax rate')" width="90">
                  <template #default="scope">
                    <el-text v-if="data.shop">{{ scope.row.hasTax ? math.formatNumber(math.multiply(
                      math.plus(data.shop.hstRate, data.shop.gstRate, data.shop.pstRate, data.shop.qstRate)
                      , 100), 4) + '%' : '0%' }}</el-text>
                  </template>
                </el-table-column>
              </el-table>
              <el-form :inline="true" style="text-align: right;">
                <el-form-item :label="util.language('商品总价', 'Product amount')">
                  <el-text type="danger">C${{ totalAmount }}</el-text>
                </el-form-item>
                <el-form-item :label="util.language('总成本', 'Total cost')">
                  <el-text type="danger">C${{ totalCost }}</el-text>
                </el-form-item>
                <el-form-item v-if="data.shop.hstRate" :label="util.language('HST税费', 'HST amount')">
                  <el-text type="danger">C${{ hstAmount }}</el-text>
                </el-form-item>
                <el-form-item v-if="data.shop.gstRate" :label="util.language('GST税费', 'GST amount')">
                  <el-text type="danger">C${{ gstAmount }}</el-text>
                </el-form-item>
                <el-form-item v-if="data.shop.pstRate" :label="util.language('PST税费', 'PST amount')">
                  <el-text type="danger">C${{ pstAmount }}</el-text>
                </el-form-item>
                <el-form-item v-if="data.shop.qstRate" :label="util.language('QST税费', 'QST amount')">
                  <el-text type="danger">C${{ qstAmount }}</el-text>
                </el-form-item>
                <el-form-item :label="util.language('税后优惠', 'Discount amount')">
                  <el-text type="danger">C${{ data.discountAmount }}</el-text>
                </el-form-item>
                <el-form-item :label="util.language('总利润', 'Total profit')">
                  <el-text type="danger">C${{ math.plus(totalAmount, -totalCost, -data.discountAmount) }}</el-text>
                </el-form-item>
                <el-form-item :label="util.language('利润率', 'Profit rate')">
                  <el-text type="danger">{{ math.halfUp(math.divide(math.plus(totalAmount, -totalCost, -data.discountAmount), totalAmount, 0.01), 2) + '%' }}</el-text>
                </el-form-item>
                <el-form-item :label="util.language('订单总价', 'Final amount')">
                  <el-text type="danger" style="font-size: large; font-weight: bolder;">C${{ math.formatNumber(math.plus(totalAmount, taxAmount, -data.discountAmount)) }}</el-text>
                </el-form-item>
              </el-form>
              <el-form :inline="true" style="text-align: right;">
                <el-form-item>
                  <el-button type="primary" @click="clickSubmit" :loading="loading.submit">{{ util.language('确认下单', 'Confirm order') }}</el-button>
                </el-form-item>
              </el-form>
            </template>
            <template v-else>
              <el-text>{{ util.language('未选择商品', 'Product not selected') }}</el-text>
            </template>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <div style="height: 10px;"></div>
  </div>
</template>

<script setup>
import { reactive, computed } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const shopId = cache.getString(cache.keys.shopId) * 1
if (!shopId) {
  ElMessage.error(util.language('请先选择店铺', 'Please select a shop first'))
}
const changeShop = (shopItem) => {
  if (shopId == shopItem.id) {
    return
  }
  cache.setString(cache.keys.shopId, shopItem.id)
  ElMessage.success(util.language('已切换店铺', 'Shop changed'))
  setTimeout(() => {
    location.reload()
  }, 1000)
}

const router = useRouter()
/** 展示的数据 */
const show = reactive({
  tab: 'tabShop',
  shopList: [],
  customerList: [],
  customerAddressList: [],
  productTypeList: [],
  productTypeTab: 'search',
  productPageNum: 1,
  productList: [],
  productTotal: 0,
})

const productSearchParam = reactive({})
/** 重置商品查询条件 */
const resetProductSearchParam = () => {
  productSearchParam.pageNum = 1
  productSearchParam.pageSize = 48
  productSearchParam.typeId = ''
  productSearchParam.codeLike = ''
  productSearchParam.nameLike = ''
}
resetProductSearchParam()

/** 加载中 */
const loading = reactive({
  customer: false,
  customerAddress: false,
  findProduct: false,
  submit: false,
})

/** 用户操作、选择的数据 */
const data = reactive({
  shop: {}, // 店铺
  customer: null, // 客户
  customerAddress: null, // 客户地址
  productList: [], // 商品列表（含数量）
  discountAmount: 0, // 优惠金额
  scheduleDeliveryDate: null, // 预定送货日期
  orderNote: '', // 订单备注
  insiderNote: '', // 内部备注
})

/** 查询店铺信息 */
api.get('/backend/user/getMyInfo').then(res => {
  show.shopList = res.shopList
  for (const shop of show.shopList) {
    if (shopId == shop.id) {
      data.shop = shop
      break
    }
  }
  if (shopId && !data.shop.id) {
    ElMessage.error(util.language('请重新选择店铺', 'Please select a shop first'))
    cache.setString(cache.keys.shopId)
  }
})

/** 请先选择客户地址 */
const pleaseSelectCustomerAddress = () => {
  if (!data.customer || !data.customer.id || !data.customerAddress) {
    ElMessage.error(util.language('请先选择客户地址', 'Please select a customer first'))
    setTimeout(() => {
      show.tab = 'tabCustomer'
    }, 1000)
    return true
  }
  return false
}

/** 请先选择预约送货日期 */
const pleaseSelectScheduleDeliveryDate = () => {
  if (!data.scheduleDeliveryDate) {
    ElMessage.error(util.language('请先选择预约送货日期', 'Please select a schedule delivery date first'))
    setTimeout(() => {
      show.tab = 'tabCustomer'
    }, 1000)
    return true
  }
  return false
}

/** 请先选择商品 */
const pleaseSelectProduct = () => {
  if (data.productList.length === 0) {
    ElMessage.error(util.language('请先选择商品', 'Please select products first'))
    setTimeout(() => {
      show.tab = 'tabProduct'
    }, 1000)
    return true
  }
  return false
}

/** 请检查数量是否正确 */
const pleaseCheckProductQuantity = () => {
  if (data.productList.filter(item => item.quantity <= 0).length > 0) {
    ElMessage.error(util.language('请检查数量是否正确', 'Please check the quantity is correct'))
    setTimeout(() => {
      show.tab = 'tabCart'
    }, 1000)
    return true
  }
  return false
}

/** 点击顶部Tab切换 */
const tabClick = (t) => {
  const tabName = t.props.name
  if (tabName === 'tabCustomer') {
    //
  } else if (tabName === 'tabProduct') {
    // 
  } else if (tabName === 'tabCart') {
    if (pleaseSelectProduct()) { return }
  } else if (tabName === 'tabOrder') {
    if (pleaseSelectCustomerAddress()) { return }
    if (pleaseSelectScheduleDeliveryDate()) { return }
    if (pleaseSelectProduct()) { return }
    if (pleaseCheckProductQuantity()) { return }
  }
}

const customerSearchParam = reactive({})
/** 重置客户查询条件 */
const resetCustomerSearchParam = () => {
  customerSearchParam.pageNum = 1
  customerSearchParam.pageSize = 25
  customerSearchParam.shopId = shopId
  customerSearchParam.codeLike = ''
  customerSearchParam.phoneLike = ''
  customerSearchParam.nameLike = ''
}
resetCustomerSearchParam()

/** 查询客户List */
const commitFindCustomer = () => {
  loading.customer = true
  api.get('/backend/customer/getCustomerPage', { params: customerSearchParam }).then(res => {
    show.customerList = res.list
  }).finally(() => {
    loading.customer = false
  })
}
commitFindCustomer()

/** 选中客户 */
const selectCustomer = (row) => {
  if (row.enable === false) {
    ElMessage.error(util.language('该客户已被禁用', 'This customer has been disabled'))
    return
  }
  data.customer = row
  getCustomerAddress()
}

/** 点击重新选择客户 */
const reselectCustomer = () => {
  data.customer = null
  data.customerAddress = null
}

/** 查询地址List */
const getCustomerAddress = () => {
  if (data.customer) {
    loading.customerAddress = true
    api.get('/backend/customer/getCustomerAddressList', {
      params: {
        customerId: data.customer.id
      }
    }).then(res => {
      show.customerAddressList = res.list
    }).finally(() => {
      loading.customerAddress = false
    })
  } else {
    show.customerAddressList = []
  }
}

/** 选中地址 */
const addressClick = (address) => {
  data.customerAddress = address
}

/** 点击新增地址 */
const addAddressClick = () => {
  const customer = data.customer
  cache.setObject(cache.keys.pageParam + 'customerAddress', { customerId: customer.id })
  window.open(router.resolve('/customerAddress').href, '_blank')
}

/** 进入页面，查询全部商品分类 */
api.get('/backend/product/getProductType').then(res => {
  show.productTypeList = res.list
  resetProductSearchParam()
  productSearchParam.typeId = res.list[0].id
})

/** 查询商品（分页） */
const commitFindProduct = (reset) => {
  if (reset) {
    show.productList = []
    show.productTotal = 0
  }
  const params = {
    pageNum: productSearchParam.pageNum,
    pageSize: productSearchParam.pageSize,
    shopId: shopId,
    typeId: productSearchParam.typeId,
    codeLike: productSearchParam.codeLike,
    nameLike: productSearchParam.nameLike,
    enable: true,
  }
  loading.findProduct = true
  api.get('/backend/product/getProductPage', {
    params
  }).then(res => {
    show.productList.push(...res.list)
    show.productTotal = res.total
  }).finally(() => {
    loading.findProduct = false
  })
}
commitFindProduct(true)

/** 点击商品分类（El事件绑定用） */
const productTypeClick = (t) => {
  const tabName = t.props.name
  if (tabName == 'search') {
    resetProductSearchParam()
    show.productList = []
    show.productTotal = 0
  } else {
    resetProductSearchParam()
    productSearchParam.typeId = tabName
    commitFindProduct(true)
  }
}

/** 下一页商品 */
const nextProductPage = () => {
  productSearchParam.pageNum = productSearchParam.pageNum + 1
  commitFindProduct(false)
}

/** 选中，向购物车添加商品 */
const addProduct = (product) => {
  const thisProductList = data.productList.filter(item => item.id === product.id);
  if (thisProductList.length == 0) {
    product.quantity = 1
    data.productList.push(product)
  }
  // else {
  //   data.productList = data.productList.filter(item => item.id !== product.id)
  //   ElMessage.success('已从选择的商品中移除')
  // }
}

/** 从购物车移除商品 */
const removeProduct = (product) => {
  data.productList = data.productList.filter(item => item.id !== product.id)
}

/** 不含税总金额 */
const totalAmount = computed(() => {
  let result = 0
  data.productList.forEach(product => {
    if (product.quantity) {
      result = math.plus(result, math.halfUp(math.multiply(product.quantity, product.unitPerPiece, product.unitPrice), 2))
    }
  })
  return math.halfUp(result, 2)
})

/** 总成本（不含税） */
const totalCost = computed(() => {
  let result = 0
  data.productList.forEach(product => {
    if (product.quantity) {
      result = math.plus(result, math.halfUp(math.multiply(product.quantity, product.unitPerPiece, product.unitPriceIn), 2))
    }
  })
  return math.halfUp(result, 2)
})

/** 总税款 */
const taxAmount = computed(() => {
  return math.plus(hstAmount.value, gstAmount.value, pstAmount.value, qstAmount.value)
})

/** 需要上税的金额 */
const needTaxAmount = computed(() => {
  let amount = 0
  data.productList.forEach(product => {
    if (product.hasTax && product.quantity) {
      amount = math.plus(amount, math.halfUp(math.multiply(product.quantity, product.unitPerPiece, product.unitPrice), 2))
    }
  })
  return amount
})

/** HST税额 */
const hstAmount = computed(() => {
  if (data.shop && data.shop.hstRate) {
    return math.halfUp(math.multiply(needTaxAmount.value, data.shop.hstRate), 2)
  } else {
    return 0
  }
})

/** GST税额 */
const gstAmount = computed(() => {
  if (data.shop && data.shop.gstRate) {
    return math.halfUp(math.multiply(needTaxAmount.value, data.shop.gstRate), 2)
  } else {
    return 0
  }
})

/** PST税额 */
const pstAmount = computed(() => {
  if (data.shop && data.shop.pstRate) {
    return math.halfUp(math.multiply(needTaxAmount.value, data.shop.pstRate), 2)
  } else {
    return 0
  }
})

/** QST税额 */
const qstAmount = computed(() => {
  if (data.shop && data.shop.qstRate) {
    return math.halfUp(math.multiply(needTaxAmount.value, data.shop.qstRate), 2)
  } else {
    return 0
  }
})

/** 点击下单按钮 */
const clickSubmit = () => {
  if (!data.shop || !data.shop.id) {
    ElMessage.error(util.language('请选择店铺', 'Please select a store'))
    return
  }
  if (!data.customer || !data.customer.id) {
    ElMessage.error(util.language('请选择客户', 'Please select a customer'))
    return
  }
  if (!data.customerAddress) {
    ElMessage.error(util.language('请选择客户地址', 'Please select a address'))
    return
  }
  if (!data.scheduleDeliveryDate) {
    ElMessage.error(util.language('请选择预约送货日期', 'Please select a delivery date'))
    return
  }
  if (data.productList.length == 0) {
    ElMessage.error(util.language('请选择商品', 'Please select products'))
    return
  }
  const orderMaster = {
    shopId: data.shop.id,
    customerId: data.customer.id,
    addressContact: data.customerAddress.contact,
    addressPhone: data.customerAddress.phone,
    addressGooglePlaceId: data.customerAddress.googlePlaceId,
    addressLat: data.customerAddress.lat,
    addressLng: data.customerAddress.lng,
    addressOpeningHours: data.customerAddress.openingHours,
    addressDetail: data.customerAddress.addressDetail,
    scheduleDeliveryDate: data.scheduleDeliveryDate,
    totalAmount: totalAmount.value,
    hstRate: data.shop.hstRate,
    gstRate: data.shop.gstRate,
    pstRate: data.shop.pstRate,
    qstRate: data.shop.qstRate,
    hstAmount: hstAmount.value,
    gstAmount: gstAmount.value,
    pstAmount: pstAmount.value,
    qstAmount: qstAmount.value,
    discountAmount: data.discountAmount,
    finalAmount: math.plus(totalAmount.value, taxAmount.value, -data.discountAmount),
    customerNote: '',
    orderNote: data.orderNote || '',
    insiderNote: data.insiderNote || '',
    insiderNoteImg: '[]',
  }
  const orderDetailList = []
  for (const product of data.productList) {
    if (!product.quantity) {
      ElMessage.error(util.language('商品数量不能为空，请仔细核对', 'Quantity cannot be empty'))
      return
    }
    orderDetailList.push({
      productId: product.id,
      unitPrice: product.unitPrice,
      pieceQuantity: product.quantity,
      unitQuantity: math.multiply(product.quantity, product.unitPerPiece),
      finalAmount: math.halfUp(math.multiply(product.quantity, product.unitPerPiece, product.unitPrice), 2),
    })
  }
  ElMessageBox.confirm(util.language('您已经仔细核对订单信息，并确认要下单吗？', 'You have carefully checked the order information and confirmed to place an order?'),
    util.language('确认下单', 'Confirm order'), {
    confirmButtonText: util.language('确认下单', 'OK'),
    cancelButtonText: util.language('取消', 'Cancel'),
  }).then(() => {
    if (loading.submit == true) { return }
    loading.submit = true
    api.post('/backend/order/addOrder', {
      orderMaster: orderMaster,
      orderDetailList: orderDetailList
    }).then(res => {
      ElMessageBox.alert(
        util.language('单号：' + res.code, 'Order code: ' + res.code),
        util.language('下单成功', 'Success'), {
        confirmButtonText: util.language('确认', 'OK')
      }).then(() => {
        router.go(0)
      })
    }).finally(() => {
      loading.submit = false
    })
  })
}
</script>

<style lang="less">
.addOrder {
  margin: auto;
  // max-width: 900px;
}
</style>